import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-family: 'Poppins', sans-serif;
    h1 {
        font-size: 2.5rem;
        font-weight: 600;
        color: rgb(58,59,60);
        text-align: center;
    }
    h2 {
        font-size: 1.5rem;
        font-weight: 600;
        color: rgb(58,59,60);
        margin: 0;
    }
    form {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
    }
    .form-1 {
        width:100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .sub-form {
        width: 960px;
        display: flex;
        justify-content: center;
        padding-right: 5.5rem;
    }
    .sub-form-left {
        width: 960px;
        display: flex;
        justify-content: center;
        padding-right: 5.5rem;
    }
    .select_input {
        width: 50%;
        display: flex;
        justify-content: flex-end;
        .select {
            line-height: 33px;
            padding: 0.9rem 0rem;
            padding-right: 4.1%;
            width: 466px;
        }
    }
    .select_input_right {
        width: 50%;
        display: flex;
        justify-content: start;
        .select {
            line-height: 32px;
            padding: 0.9rem 0rem;
            padding-left: 1%;
            width: 466px;
        }
    }
    .select_input_2 {
        margin-left: 20px;
        margin-right: 0.5rem;
        .select {
            line-height: 32px;
            padding: 0.9rem 0rem;
            padding-left: 1%;
            width: 246px;
        }
    }
    .select_input_right_2 {
        margin-left: 10px;
        .select {
            line-height: 32px;
            padding: 0.9rem 0rem;
            padding-left: 1%;
            width: 188px;
        }
    }
    .checkbox {
        width: 159px;
        padding:  1.3rem 0rem;
    }
    .div_button {
        display: flex;
        justify-content: center;
        width: 100%;
        padding-top: 1.5rem;
        padding-bottom: 3rem;
        padding-right: 2.3rem;
        margin-left: 1rem;
        .button {
            width: 30%;
        }
    }

    .signup-div{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10vh;
        .signup-button {
            max-width: 35rem;
        }
    }
   

    @media screen and (max-width: 1400px){
        h1 {
            font-size: 2.2rem;
        }
    

    @media screen and (max-width: 1010px){
        h1 {
            font-size: 2.2rem;
        }
        .sub-form {
            width:100%;
            display: flex;
            justify-content: center;
            padding-right: 5%;
        }
        .sub-form-left {
            width:100%;
            display: flex;
            justify-content: center;
            padding: 0;
            padding-right: 5%;
        }
        .select_input {
            padding: 0.4rem 0rem 0.4rem 4.1rem;
            width: 100%;
            padding-right: 0;
            justify-content: center;
            padding-right: 5%;
        }
        .select_input_right {
            width: 100%;
            display: flex;
            justify-content: center;
            padding-left: 3rem;
            padding-right: 5%;
            .select {
                padding-left: 1.7%;
        } }
        .select_input_right_2 {
            padding-right: 0%;
            width: 135px;
        }
        .select_input_2 { .select {
            width: 261px;
        } }
    }

    @media screen and (max-width: 850px){
        .select_input_right {
            padding-left: 3.18rem;
        }
    }
    @media screen and (max-width: 610px){
        display: flex;
        justify-content: center;
        margin: 0;
        h1 {
            font-size: 1.8rem;
        }
        h2 {
            font-size: 1.3rem;
        }
        .sub-form {
            width:80%;
            margin-left: 10%;
            display: flex;
            flex-direction: column;
        }
        .sub-form-left, .select_input_right_2 {
            width:80%;
            margin-left: 10%;
            display: flex;
            flex-direction: column;
        }
        .select_input {
            justify-content: start;
            width:76.5%;
            margin-left: 10%;
            padding: 0.4rem 0rem 0rem 0.65rem;
        }
        .select_input_right {
            justify-content: start;
            width:78%;
            margin-left: 10%;
            padding-left: 0;
            /* padding: 0.4rem 0rem 0.4rem 0.65rem; */
            .select {
                width: 100%;
            }
        }
        .select_input_right_2 { 
            width: 100%;
            margin-left: 1%;
            .select {
                width: 96%;
        } }
        .select_input_2 { 
            display: flex;
            justify-content: start;
            margin-left: 1%;
            .select {
                width: 98.5%;
        } }
        .checkbox {
            padding:  1.3rem 4%;
        }
        .div_button {
            justify-content: start;
            padding: 0;
            margin-right: 10%;
            margin-left: 10%;
            .button {
                width: 95%;
            }
        }
    }

    @media screen and (max-width: 500px){
        .sub-form {
            margin-left: 8%;
        }
        .sub-form-left {
            margin-left: 8%;
        }
        .select_input {
            margin-left: 8%;
            width: 79.5%;
        }
        .select_input_right {
            margin-left: 8%;
            width: 82%;
        }
        .select_input_2 { 
            margin-left: 2%;
            width: 101%;
        }
        .select_input_right_2 { .select {
            margin-left: 1%;
            width: 100%;
        } }
        .div_button {
            margin-left: 8%;
        }
        
    }
    @media screen and (max-width: 400px){
        .sub-form {
            margin-left: 6%;
        }
        .sub-form-left {
            margin-left: 6%;
        }
        .select_input {
            margin-left: 6%;
            width: 82%;
        }
        .select_input_right {
            margin-left: 7%;
            width: 84%;
        }
        .select_input_2 { 
            margin-left: 2%;
            width: 104%;
        }
        .select_input_right_2 { .select {
            margin-left: 1%;
            width: 103%;
        } }
        .div_button {
            margin-left: 6%;
            margin-right: 6%;
        }
    }
    @media screen and (max-width: 350px){
        .sub-form {
            margin-left: 4%;
        }
        .sub-form-left {
            margin-left: 4%;
        }
        .select_input {
            margin-left: 4%;
            width: 85%;
        }
        .select_input_right {
            margin-left: 5%;
            width: 87%;
        }
        .select_input_2 { 
            margin-left: 3%;
            width: 107%;
        }
        .select_input_right_2 { .select {
            margin-left: 2%;
            width: 107%;
        } }
        .div_button {
            margin-left: 4%;
            margin-right: 4%;
        }
    }
    @media screen and (max-width: 300px){
        .select_input {
            width: 88%;
        } 
        .select_input_right {
            width: 90%;
        } 
        .select_input_2 { 
            width: 111%;
        }
        .select_input_right_2 { .select {
            width: 111%;
        } }
    }
`
